import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/readme',
      component: (resolve) =>
        require(['../components/common/Home.vue'], resolve),
      children: [
        {
          path: '',
          redirect: 'home'
        },
        {
          path: 'home',
          component: (resolve) =>
            require(['../components/page/Homepage.vue'], resolve)
        },
        {
          path: 'regionManagement',
          component: (resolve) =>
            require([
              '../components/page/document/regionManagementPage.vue'
            ], resolve)
        },
        {
          path: 'information',
          component: (resolve) =>
            require([
              '../components/page/setting/informationManagePage.vue'
            ], resolve)
        },
        {
          path: 'changePassword',
          component: (resolve) =>
            require([
              '../components/page/setting/changePasswordPage.vue'
            ], resolve)
        },
        {
          path: 'ammeterManagement',
          component: (resolve) =>
            require([
              '../components/page/device/ammeterManagePage.vue'
            ], resolve)
        },
        {
          path: 'ammeterDetails/:id',
          component: (resolve) =>
            require(['../components/page/device/NewDetailPage.vue'], resolve)
        },
        {
          path: 'collectorManagement',
          component: (resolve) =>
            require([
              '../components/page/device/collectorManagePage.vue'
            ], resolve)
        },
        {
          path: 'ammeterTypeManagement',
          component: (resolve) =>
            require([
              '../components/page/document/ammeterTypeManagePage.vue'
            ], resolve)
        },
        {
          path: 'crontabManagement',
          component: (resolve) =>
            require([
              '../components/page/crontab/crontabManagementPage.vue'
            ], resolve)
        },
        {
          path: 'ammeterDataReportManagement',
          component: (resolve) =>
            require([
              '../components/page/report/ammeterDataReportManagementPage.vue'
            ], resolve)
        },
        {
          path: 'powerDataReport',
          component: (resolve) =>
            require(['../components/page/report/powerDataReport.vue'], resolve)
        },
        {
          path: 'ammeterHistoryManagement',
          component: (resolve) =>
            require([
              '../components/page/history/ammeterHistoryManagePage.vue'
            ], resolve)
        },
        {
          path: 'ammeterOpHistory',
          component: (resolve) =>
            require([
              '../components/page/history/ammeterOpHistoryPage.vue'
            ], resolve)
        },

        // {
        //   path: 'personalPaymentManagement',
        //   component: resolve => require(['../components/page/history/personalPaymentManagePage.vue'], resolve)
        // },
        {
          path: 'electrovalenceManagement',
          component: (resolve) =>
            require([
              '../components/page/price/electrovalenceManagePage.vue'
            ], resolve)
        },
        {
          path: 'authManagement',
          component: (resolve) =>
            require([
              '../components/page/systemSetting/authManagePage.vue'
            ], resolve)
        },
        {
          path: 'roleManagement',
          component: (resolve) =>
            require([
              '../components/page/systemSetting/roleManagePage.vue'
            ], resolve)
        },
        {
          path: 'userManagement',
          component: (resolve) =>
            require(['../components/page/user/userManagePage.vue'], resolve)
        },
        {
          path: 'operatorManagement',
          component: (resolve) =>
            require([
              '../components/page/user/operatorManagementPage.vue'
            ], resolve)
        },
        {
          path: 'secondLevelManagerManagement',
          component: (resolve) =>
            require([
              '../components/page/user/secondLevelManagerPage.vue'
            ], resolve)
        },
        {
          path: 'thirdLevelManagerManagement',
          component: (resolve) =>
            require([
              '../components/page/user/thirdLevelManagerPage.vue'
            ], resolve)
        },
        {
          path: 'charge/chargeSuccess',
          component: (resolve) =>
            require(['../components/page/charge/chargeSuccess.vue'], resolve)
        },
        {
          path: 'charge/chargeFailed',
          component: (resolve) =>
            require(['../components/page/charge/chargeFailed.vue'], resolve)
        },
        {
          path: 'finance/financeAccount',
          component: (resolve) =>
            require(['../components/page/finance/financeAccount.vue'], resolve)
        },
        {
          path: 'finance/financeAccount/add',
          component: (resolve) =>
            require([
              '../components/page/finance/addFinanceAccount.vue'
            ], resolve)
        },
        {
          path: 'finance/receiveRecord',
          component: (resolve) =>
            require(['../components/page/finance/receiveRecord.vue'], resolve)
        }
      ]
    },
    {
      path: '/login',
      component: (resolve) => require(['../components/page/Login.vue'], resolve)
    },
    {
      path: '/register',
      component: (resolve) =>
        require(['../components/page/Register.vue'], resolve)
    },
    {
      path: '/forgetPassword',
      component: (resolve) =>
        require(['../components/page/forgetPassword.vue'], resolve)
    },
    {
      path: '/fastCharge',
      component: (resolve) =>
        require(['../components/page/fast-charge.vue'], resolve)
    },
    {
      path: '/chargePage/:id',
      component: (resolve) =>
        require(['../components/page/charge/chargePage.vue'], resolve)
    },
    {
      path: '/rechargeWakeupAlipay',
      component: (resolve) =>
        require(['../components/page/charge/rechargeWakeupAlipay.vue'], resolve)
    },
    {
      path: '/charge/chargeSuccess',
      component: (resolve) =>
        require(['../components/page/charge/chargeSuccess.vue'], resolve)
    },
    {
      path: '/charge/chargeFailed',
      component: (resolve) =>
        require(['../components/page/charge/chargeFailed.vue'], resolve)
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js